import React from 'react';
import styles from './style.module.css';

enum Variant {
  default = 'default',
  info = 'info',
  error = 'error',
  success = 'success',
  warning = 'warning',
}
enum Size {
  small = 'small',
  large = 'large',
}

type TagProps = {
  children: React.ReactNode;
  variant?: keyof typeof Variant;
  size?: keyof typeof Size;
  onClick?: () => void;
  className?: string;
  as?: 'span' | 'button';
  'aria-label'?: string;
};

export function Tag({
  children,
  variant = 'default',
  size = 'small',
  onClick,
  className,
  as,
  ...aria
}: TagProps) {
  const Comp = as ?? (onClick ? 'button' : 'span');
  return (
    <Comp
      type={Comp === 'button' ? 'button' : undefined}
      className={[
        styles.tag,
        styles[`variant-${variant}`],
        styles[`size-${size}`],
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      {...aria}
    >
      {children}
    </Comp>
  );
}

export function TagGroup({
  label,
  children,
  className,
}: {
  label?: string;
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={[styles.group, className].filter(Boolean).join(' ')}
      role="list"
      aria-label={label}
    >
      {React.Children.map(children, (child) => (
        <div role="listitem">{child}</div>
      ))}
    </div>
  );
}
